import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sd-discover-banner',
  standalone: true,
  imports: [],
  templateUrl: './discover-banner.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./discover-banner.component.scss']
})
export class SdDiscoverBannerComponent {
  @Input()
  discoverBrandsText: string;
}
